module.exports = __webpack_public_path__ + "media/LACHSONG_RODRIGO.454e79d6.mp3";